import { FontSizes } from '@fluentui/react';

var pivotStyles = {
    root: {
        marginTop: '24px',
        textAlign: 'center',
        whiteSpace: 'pre-wrap'
    },
    text: {
        fontSize: FontSizes.size18
    },
    link: {
        margin: '0 12px'
    },
    linkIsSelected: {
        '&::before': {
            transition: 'none',
            right: '0',
            left: '0',
            '&:hover': {
                right: '0',
                left: '0'
            }
        }
    }
};
var linkStyles = {
    root: {
        marginTop: '24px',
        textDecoration: 'underline'
    }
};

export { linkStyles, pivotStyles };
